import { TaskWaiter } from 'df-helpers/dist/mem-cache/task-waiter';
import { g_busySpinner } from '../react-model-ui/form/h-global-busy-spinner';
import { ReactModel } from '../react-model/react-model';

/**
 * @description Reload a model.
 * 1. If loaded already, then do nothing if 'option.reload' is false
 * 2. Concurrent calls are merged into a single call.
 * 3. optionally:
 *		1. display the global spinner
 *		2. Set the "is_loading" flag in the model
 *
 * @param model The model to be reloaded, it must contain a field "is_loaded"
 * @param func_loader the function that will load data to the model.
 * @param options reload: false to use cache, true to reload; spin: display a spinner
 * @returns
 */
export async function reloadModel<T extends { is_loaded: boolean }>(
	model: ReactModel<T>,
	func_loader: () => Promise<any>,
	options?: {
		/** if true, reload even if the model has been loaded. Default only load once */
		reload?: boolean;
		/**Show the global spinner */
		spin?: boolean;
		/** Set the "is_loading" field in the model */
		field_is_loading?:keyof T
	}
) {
	//if loaded already, nothing to be done
	if (!options?.reload && model.getState().is_loaded) return;

	//keep "wait_flag" with the model
	const m2: { _wait_flag: TaskWaiter } = model as any;
	if (!m2._wait_flag) {
		m2._wait_flag = new TaskWaiter();
	}
	const wait_flag = m2._wait_flag;

	//if is loading, then wait
	if (wait_flag.isInProgress('0')) {
		return await wait_flag.waitFor('0');
	}
	//do the actual load
	wait_flag.start('0');
	const field_is_loading = options?.field_is_loading;
	if (options?.spin) g_busySpinner.show(true);
	try {
		field_is_loading && model.setProperty({[field_is_loading]:true} as any);
		const value = await func_loader();
		wait_flag.stop('0', value, null);
	} catch (ex) {
		wait_flag.stop('0', null, ex as Error);
		throw ex;
	} finally {
		field_is_loading && model.setProperty({[field_is_loading]:false} as any);
		if (options?.spin) g_busySpinner.show(false);
	}
}
